module.exports = __webpack_public_path__ + "img/price-1904x640.da53c002.jpg";